import { useMemo } from 'react'

export type AssetColor = 'green' | 'pink' | 'purple' | 'yellow' | 'blue' | 'character' | 'chainOffer'

export const useAssetColor = (id: string): AssetColor => {
  // TODO: add the proper color scheme for each asset

  return useMemo(() => {
    if (id === '800019') return 'pink'
    if (id === '300031') return 'blue'
    if (id === '300000') return 'yellow'

    return 'yellow'
  }, [id])
}
